import React from 'react';
import {
  AppstoreOutlined,
  TeamOutlined,
  MessageOutlined,
  CalendarOutlined,
  UserOutlined,
  BankOutlined,
} from '@ant-design/icons';
import { MENU_TRANSLATION_KEYS as K } from '../constants/menuTranslationKeys';

export interface MenuItemConfig {
  key: string;
  translationKey: number;
  icon: React.ReactNode;
  path?: string;
  children?: MenuItemConfig[];
}

export const MENU_CONFIG: MenuItemConfig[] = [
  {
    key: 'advertisements',
    translationKey: K.ADVERTISEMENTS,
    icon: <AppstoreOutlined />,
    path: '/advertisements',
    children: [
      {
        key: 'all-advertisements',
        translationKey: K.ALL_ADVERTISEMENTS,
        icon: <AppstoreOutlined />,
        path: '/advertisements/all',
      },
      {
        key: 'received-offers',
        translationKey: K.RECEIVED_OFFERS,
        icon: <AppstoreOutlined />,
        path: '/advertisements/received-offers',
      },
   
      {
        key: 'boosted-to-me',
        translationKey: K.BOOSTED_TO_ME,
        icon: <AppstoreOutlined />,
        path: '/advertisements/boosted',
      },
         {
        key: 'new-adv',
        translationKey: K.NEW_ADVERTISEMENTS,
        icon: <AppstoreOutlined />,
        path: '/advertisements/new',
      },
    ],
  },
   
{
        key: 'advertisement-management',
        translationKey: K.ADVERTISEMENT_MANAGEMENT,
        icon: <AppstoreOutlined />,
        path: '/advertisements/management',
         children: [

{
        key: 'my-related-advertisements',
        translationKey: K.MY_RELATED_ADVERTISEMENTS,
        icon: <AppstoreOutlined />,
        path: '/advertisements/related',
      },
      {
        key: 'received-prices',
        translationKey: K.RECEIVED_PRICES,
        icon: <AppstoreOutlined />,
        path: '/advertisements/prices',
      },
      {
        key: 'sent-boosts',
        translationKey: K.SENT_BOOSTS,
        icon: <AppstoreOutlined />,
        path: '/advertisements/sent-boosts',
      },
         ]
      },
      
    
  {
    key: 'partner-companies',
    translationKey: K.PARTNER_COMPANIES,
    icon: <TeamOutlined />,
    path: '/partners',
    children: [
      {
        key: 'partner-companies-list',
        translationKey: K.PARTNER_COMPANIES_LIST,
        icon: <TeamOutlined />,
        path: '/partners/list',
      },
      {
        key: 'corporate-invitations',
        translationKey: K.CORPORATE_INVITATIONS,
        icon: <TeamOutlined />,
        path: '/partners/invitations',
      },
    ],
  },
  {
    key: 'chat',
    translationKey: K.CHAT,
    icon: <MessageOutlined />,
    path: '/chat',
  },
  {
    key: 'events',
    translationKey: K.EVENTS,
    icon: <CalendarOutlined />,
    path: '/events',
  },
  {
    key: 'personal-profile',
    translationKey: K.PERSONAL_PROFILE,
    icon: <UserOutlined />,
    path: '/profile/personal',
    children: [
      {
        key: 'personal-information',
        translationKey: K.PERSONAL_INFORMATION,
        icon: <UserOutlined />,
        path: '/profile/personal/info',
      },
      {
        key: 'change-password',
        translationKey: K.CHANGE_PASSWORD,
        icon: <UserOutlined />,
        path: '/profile/personal/password',
      },
      {
        key: 'received-invitations',
        translationKey: K.RECEIVED_INVITATIONS,
        icon: <UserOutlined />,
        path: '/profile/personal/invitations',
      },
    ],
  },
   {
    key: 'company-profile',
    translationKey: K.COMPANY_PROFILE,
    icon: <BankOutlined />,
    path: '/company',
    children: [
      {
        key: 'company-main-info',
        translationKey: K.COMPANY_MAIN_INFO,
        icon: <BankOutlined />,
        path: '/company/info',
      },
      {
        key: 'staff-invitations',
        translationKey: K.STAFF_INVITATIONS,
        icon: <BankOutlined />,
        path: '/company/staff-invitations',
      },
      {
        key: 'organizational-chart',
        translationKey: K.ORGANIZATIONAL_CHART,
        icon: <BankOutlined />,
        path: '/company/org-chart',
      },
      {
        key: 'company-addresses',
        translationKey: K.COMPANY_ADDRESSES,
        icon: <BankOutlined />,
        path: '/company/addresses',
      },
      {
        key: 'company-categories',
        translationKey: K.COMPANY_CATEGORIES,
        icon: <BankOutlined />,
        path: '/company/categories',
      },
      {
        key: 'company-evaluation-profile',
        translationKey: K.COMPANY_EVALUATION_PROFILE,
        icon: <BankOutlined />,
        path: '/company/evaluation',
      },
    ],
  },
];
